import appApi from "services/API";

const logOut = () => appApi.post("logout");

export default {
  logOut,
};
